import { render, staticRenderFns } from "./LinkPagination.vue?vue&type=template&id=67ba78db&scoped=true&"
import script from "./LinkPagination.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LinkPagination.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LinkPagination.vue?vue&type=style&index=0&id=67ba78db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba78db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ba78db')) {
      api.createRecord('67ba78db', component.options)
    } else {
      api.reload('67ba78db', component.options)
    }
    module.hot.accept("./LinkPagination.vue?vue&type=template&id=67ba78db&scoped=true&", function () {
      api.rerender('67ba78db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LinkPagination/LinkPagination.vue"
export default component.exports